export interface TipCardData {
  id: string;
  title: string | null;
  text: string;
  ctaLabel: string;
  icon: string;
  section: string;
  context: string;
  backgroundColorToken: string;
  iconBgColorToken: string;
  iconColorToken: string;
  isDismissible: boolean;
}

export const tipcardsData: TipCardData[] = [
  {
    id: "speed",
    title: null,
    text: "Clientes pagaram para aparecer aqui, indicando alto interesse em fechar um serviço.",
    ctaLabel: "Entendi",
    icon: "lightbulb",
    section: "destaque",
    context: "featured_requests",
    backgroundColorToken: "#7c3aed", // Purple for destaque section
    iconBgColorToken: "#6d28d9",
    iconColorToken: "#ffffff",
    isDismissible: true,
  },
  {
    id: "quality",
    title: null,
    text: "Avaliando os pedidos, você melhora a recomendação para você.",
    ctaLabel: "Entendi",
    icon: "lightbulb",
    section: "para_voce",
    context: "recommended_requests",
    backgroundColorToken: "#059669", // Green for para_voce section
    iconBgColorToken: "#047857",
    iconColorToken: "#ffffff",
    isDismissible: true,
  },
  {
    id: "first",
    title: null,
    text: "Liberar pedidos que ninguém liberou ainda aumentam suas chances de fechar negócio!",
    ctaLabel: "Entendi",
    icon: "lightbulb",
    section: "outros",
    context: "other_requests",
    backgroundColorToken: "#374151", // Gray for outros section
    iconBgColorToken: "#1f2937",
    iconColorToken: "#ffffff",
    isDismissible: true,
  },
  {
    id: "safety",
    title: null,
    text: "Sempre avalie o cliente após o serviço, isso ajuda a manter a plataforma mais segura.",
    ctaLabel: "Entendi",
    icon: "lightbulb",
    section: "outros",
    context: "general",
    backgroundColorToken: "#374151", // Gray for outros section
    iconBgColorToken: "#1f2937",
    iconColorToken: "#ffffff",
    isDismissible: true,
  },
  {
    id: "rating",
    title: null,
    text: "Clientes avaliam suas informações antes mesmo de responder. Mantenha seu perfil atualizado!",
    ctaLabel: "Entendi",
    icon: "lightbulb",
    section: "outros",
    context: "general",
    backgroundColorToken: "#374151", // Gray for outros section
    iconBgColorToken: "#1f2937",
    iconColorToken: "#ffffff",
    isDismissible: true,
  },
];